import { Children } from 'react'

export const defaultFormatters = {
  b: (...chunks) => <b>{Children.toArray(chunks)}</b>,

  span: (...chunks) => <span>{Children.toArray(chunks)}</span>,

  br: <br />,
}
